export type DateFormat = 'MM-DD-YYYY' | 'DD.MM.YYYY'
export type TimeFormat = '12hr' | '24hr'

export const normalizeDateFormatPreference = (value: unknown): DateFormat => {
  const normalized = String(value || '')
    .toUpperCase()
    .replace(/\./g, '-')
    .replace(/\//g, '-')
  return normalized === 'DD-MM-YYYY' ? 'DD.MM.YYYY' : 'MM-DD-YYYY'
}

export const normalizeDateFormatForSettings = (value: unknown): DateFormat => {
  return normalizeDateFormatPreference(value)
}

export const isEuropeanDateFormat = (value: unknown): boolean => {
  return normalizeDateFormatPreference(value) === 'DD.MM.YYYY'
}

export const normalizeTimeFormatPreference = (value: unknown): TimeFormat => {
  const normalized = String(value || '').toLowerCase()
  return normalized === '24hr' ? '24hr' : '12hr'
}
